import React, { useContext, useEffect, useState } from 'react';
import { flushSync } from 'react-dom';
import toast from 'react-hot-toast';
import I18n from '@utils/i18n';
import InspectionAssistantModal from '@features/InspectionAssistantModal';
import useModalContext from '@contexts/useModalContext';
import Header from './nested/Header';
import CalendarComp from './CalendarComp';
import { CalendarContext } from './CalendarContext';
/**
 * Inner Calendar page component.
 *
 * Consumes CalendarContext and ModalContext to wire together:
 * - The filter / action header (passed to CalendarComp as customFilterSection)
 * - The FullCalendar wrapper (CalendarComp)
 * - Global modals rendered by the modal context
 */
function CalendarPage({ calendarOptimizationEnabled, calendarDayMaxEvents, showNextMonthDays = false }) {
    const { state: { errorMessage, view, loading }, actions: { onDateRangeChange } } = useContext(CalendarContext);
    const { activeModal } = useModalContext();
    const [isPrinting, setIsPrinting] = useState(false);
    useEffect(() => {
        const handleBeforePrint = () => {
            flushSync(() => {
                setIsPrinting(true);
            });
        };
        const handleAfterPrint = () => {
            setIsPrinting(false);
        };
        window.addEventListener('beforeprint', handleBeforePrint);
        window.addEventListener('afterprint', handleAfterPrint);
        return () => {
            window.removeEventListener('beforeprint', handleBeforePrint);
            window.removeEventListener('afterprint', handleAfterPrint);
        };
    }, []);
    useEffect(() => {
        if (errorMessage) {
            toast.error(errorMessage, {
                position: 'bottom-right',
                duration: 3000
            });
        }
    }, [errorMessage]);
    return (React.createElement(React.Fragment, null,
        activeModal,
        loading && (React.createElement("div", { className: "qmb-loading--128--page", "data-title": I18n.t('generic.loading') },
            React.createElement("svg", { role: "img" },
                React.createElement("use", { href: "/map.svg#load-spinner" })))),
        React.createElement(CalendarComp, { view: view, onDateRangeChange: onDateRangeChange, calendarOptimizationEnabled: calendarOptimizationEnabled, calendarDayMaxEvents: calendarDayMaxEvents, showNextMonthDays: showNextMonthDays, isPrinting: isPrinting, customFilterSection: React.createElement(Header, null) }),
        React.createElement(InspectionAssistantModal, null)));
}
export default CalendarPage;
